module.exports = __webpack_public_path__ + "img/NoReviews.0bb4a3cd.svg";